export const getBalanceData = ({ balance }) => balance

export const getCatalogData = ({
  catalog: {
    currencyConfiguration: { pointsName }
  }
}) => ({ pointsName })

export const getWishlist = ({ wishlist }) => wishlist



// WEBPACK FOOTER //
// ./src/App/Header/UserProfile/selectors.js